module.exports = __webpack_public_path__ + "202222:4f4eb5d45eb7a9e97a70/img/hero_image@1x.cf87a89.png";